import React, {useRef, useState} from 'react';
import clsx from "clsx";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    logoImage: {
        cursor: 'pointer',
        display: 'inline-block',
        maxWidth: '100%',
        height: 'auto',
        padding: 0
    },
    uploadButton: {
        display: 'inline-block',
        backgroundColor: 'transparent',
        height: 64,
        width: '100%',
        marginTop: 32,
        borderRadius: 0,

        '&:hover':{
            backgroundColor: 'transparent !important',

            '& > span': {
                //backgroundColor: '#fff',
            }

        },

        '& > span.uploadButtonText': {
            backgroundColor: '#f5f5f5',
            padding: '5px 12px',
            color: '#555555',
            display: 'inline-block',
            position: 'relative',
            zIndex: 2,
            borderRadius: 5,
        },

        '&::before, &::after': {
            content: '""',
            borderBottom: '2px dashed #e0e0e0',
            display: 'inline-block',
            height: '1px',
            marginTop: -2,
            position: 'absolute',
            verticalAlign: 'middle',
            width: '50%',
            zIndex: 0
        },

        '&::before': {
            left: 0,
        },

        '&::after': {
            right: 0,
        }

    },
}));

export default function ImageUploader(props) {

    const classes = useStyles(props);

    const {logo, updateLogoData, openConfigurator} = props;

    const logoRef = useRef(null);

    const [formValues, setFormValues] = useState({
        formLogo: {
            image: logo.image,
            filename: logo.filename,
            width: logo.width,
            height: logo.height,
            alignment: logo.alignment,
        }
    });

    const [sending, setSending] = useState(false);

    const handleInputChange = (data) => {

        setFormValues({...formValues, ['formLogo']: data});

        setTimeout(function (){

            if(logoRef.current){

                data.width = logoRef.current.width;
                data.height = logoRef.current.height;

                //setFormValues({...formValues, ['formLogo']: data});

            }

            updateLogoData(data);

        });

    };

    // const openConfigurator = (e) => {
    //
    //     e.preventDefault();
    //
    //     console.log('test');
    //
    // }

    return <div className="imageUploader">

        {formValues.formLogo.image !== '' ?
            <div className={clsx('logo-wrapper', `logo-alignment-${formValues.formLogo.alignment}`)}>

                <img ref={logoRef}
                     className={classes.logoImage}
                     onClick={(e) => {
                         openConfigurator(e);
                     }}
                     src={formValues.formLogo.image} />

                <IconButton
                    sx={{position: 'absolute', right: 0, top: 0}}
                    aria-label="delete"
                    onClick={() => {
                        handleInputChange({
                            image: '',
                            filename: '',
                            width: null,
                            height: null,
                            alignment: 'center',
                        });
                    }}>
                    <CloseIcon />
                </IconButton>

            </div> :

            <Button className={classes.uploadButton}
                    disabled={false}
                    size="large"
                    variant="text"
                    component="label"
                    fullWidth>
                {sending ? <CircularProgress color="inherit" /> : <span className="uploadButtonText">Add your logo (1MB max)</span>}

                <input
                    type="file"
                    onChange={async e => {

                        function readFileAsync() {

                            return new Promise((resolve, reject) => {

                                const file = e.target.files[0];

                                if (!file || file.length === 0) {

                                    alert('The file is corrupted or selected incorrectly, please try again!')

                                    return;

                                } else {

                                    setSending(true);

                                }

                                // 1. Check file type
                                const fileExt = file.name.split('.').pop().toLowerCase();
                                const imageTypes = ["jpg", "jpeg", "gif", "png"];

                                if (!imageTypes.includes(fileExt)) {
                                    alert('Sorry, this file format not supported!');
                                    return;
                                }

                                // 2. Check file size
                                const size = file.size;

                                if (imageTypes.includes(fileExt)) {
                                    if (size > 1048576) {
                                        alert('Sorry, for images 1MB max.!');
                                        return;
                                    }
                                }

                                const fileReader = new FileReader()
                                fileReader.readAsDataURL(file);

                                fileReader.onload = () => {

                                    const logoData = {
                                        image: fileReader.result,
                                        filename: file.name,
                                        width: null,
                                        height: null,
                                        alignment: 'center',
                                    }

                                    handleInputChange(logoData);

                                    setSending(false);

                                };

                                fileReader.onerror = error => {

                                    console.log("Upload Image Error: ", error);

                                    setSending(false);

                                };

                            });

                        }

                        await readFileAsync();

                    }}
                    hidden
                />
            </Button>

        }

    </div>

}